var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 122,
    viewBox: "0 0 110 122",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EDEDED",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    d: "M6.3 60.9h95.4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 51.6)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EDEDED",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    d: "M3.9 33.9h86.4M3.9 50.1h86.4"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#EDEDED",
    strokeWidth: 0.6,
    x: 0.3,
    y: 0.3,
    width: 95.4,
    height: 61.8,
    rx: 2.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6 4.2)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1.8,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h18.6v1.2H0zM0 18.6h20.4v1.2H0zM0 23.4h11.4v1.2H0zM0 13.8h14.4V15H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.2 4.2)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1.8,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h9.6v1.2H0zM0 18.6h9.6v1.2H0zM0 23.4h9.6v1.2H0zM0 13.8h9.6V15H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.6 4.2)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1.8,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h9.6v1.2H0zM0 18.6h9.6v1.2H0zM0 23.4h9.6v1.2H0zM0 13.8h9.6V15H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.6 4.2)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1.8,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h9.6v1.2H0zM0 18.6h9.6v1.2H0zM0 23.4h9.6v1.2H0zM0 13.8h9.6V15H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84 4.2)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1.8,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h6v1.2H0zM0 18.6h6v1.2H0zM0 23.4h6v1.2H0zM0 13.8h6V15H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M66.6 37.8h9.6V39h-9.6zM84 37.8h6V39h-6zM66.6 41.4h9.6v1.2h-9.6zM84 41.4h6v1.2h-6zM66.6 45h9.6v1.2h-9.6zM66.6 54h9.6v1.8h-9.6zM84 45h6v1.2h-6zM84 54h6v1.8h-6z"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#C9C9C9",
    strokeWidth: 0.6,
    x: -0.3,
    y: -0.3,
    width: 108.6,
    height: 120.6,
    rx: 3.6
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    width: 96,
    height: 25.8,
    rx: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFBFBF",
    cx: 6.3,
    cy: 6.3,
    r: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BFBFBF",
    x: 11.4,
    y: 5.4,
    width: 16.2,
    height: 2.4,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75 5.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2,
    height: 2.4,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.2h12V6H0zM0 11.4h12v1.8H0zM0 15h7.2v1.2H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 13.2h7.2v1.2H75z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M3.6 12H24v1.2H3.6zM3.6 15H18v1.2H3.6zM3.6 18H12v1.2H3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 35.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2.4,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.4h12v1.2H0zM0 8.4h6.6v1.2H0zM0 11.4h4.2v1.2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.8 35.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2.4,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.4h12v1.2H0zM0 8.4h6.6v1.2H0zM0 11.4h4.2v1.2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.2 35.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2.4,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.4h12v1.2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84 35.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2.4,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.4h12v1.2H0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewImage);
export default __webpack_public_path__ + "static/media/preview-image.081eea34e118f49b57b8450fa414fa48.svg";
export { ForwardRef as ReactComponent };